<template>
    <ui-dropdown placement="bottom-start" :menu-class="menuClass" trigger-class="flex-1" :enabled="enabled" ref="dropdown">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto w-full z-30">

                <!-- Empty State. -->
                <div v-if="!query" class="text-gray-500 text-sm">
                    Start typing to search for items already existing in estimate...
                </div>
                <!-- Results -->
                <div v-else class="space-y-6">
                    <div v-if="items.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Existing Items</div>
                        <div class="space-y-1">
                            <div
                                v-for="item in items"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-1 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="item.description"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">
                                        <div class="truncate text-sms mx-0 pt-0.5 p-0.5">
                                            <button
                                                @mousedown="selectExistingItem(item, close)"
                                                class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                            >
                                                <span class="flex-1 w-full mr-1 relative truncate">
                                                    <span class="inline-block w-[16px] fas text-blue-600 fa-layer-group pr-1"
                                                       :class="item.bundle?'opacity-50':'opacity-0'"
                                                       style="font-size: 12px"
                                                       v-if="item.bundle"
                                                    ></span>
                                                    <span v-else class="inline-block w-[16px]">
                                                    <estimate-assembly-pinger :item="item" :estimate="estimate"
                                                      v-if="showPinger(item)"
                                                      class="top-0 left-0"></estimate-assembly-pinger>
                                                    </span>
                                                {{ item.description }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="libraryItems.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Library Items</div>
                        <div class="space-y-1">
                            <div
                                v-for="item in libraryItems"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-1 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="'('+item.group+ ') - '+item.name"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">
                                        <div class="truncate text-sms mx-0 pt-0.5 p-0.5">
                                            <button
                                                @mousedown="selectExistingItem(item.data, close)"
                                                class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                            >
                                                <span class="flex-1 w-full mr-1 truncate"><i
                                                    class="fas text-blue-600 fa-layer-group pr-1"
                                                    :class="item.data.bundle?'opacity-50':'opacity-0'"
                                                    style="font-size: 12px"
                                                ></i><span v-if="item.group" class="font-semibold mr-2">({{
                                                        item.group
                                                    }})</span>{{ item.name }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="(libraryItems.length ===0) && (items.length ===0)" class="text-gray-500 text-sm">
                        No matching existing items found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import EstimateAssemblyPinger from "./EstimateAssemblyPinger.vue";
import {Estimate} from "@models";

export default {
    components: {EstimateAssemblyPinger},
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        menuClass: {
            type: String,
            default: 'w-full',
        },
        estimate: Object,
        item: Object,
        parentItem: Object,
        estimateClipboard: [],
        enabled: true,
    },
    data() {
        return {
            query: '',
            items: [],
            libraryItems: [],
        }
    },
    computed: {},
    methods: {
        matchContact(item) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return query.every((token) => {
                return (item.description).toLowerCase().includes(token);
            });
        },
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        async setQuery(query) {
            this.query = query
            let options = []
            this.estimate.collectedItems.items.forEach((item, key) => {
                if ((item.quantity > 1) || (item.item.defaultReference !== this.item.defaultReference)) {
                    if (this.matchContact(item.item)) {
                        options.push(item.item);
                    }
                }
            })
            this.items = options.slice(0, 50);
            let matchLibrary = (item) => {
                let query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
                return query.every((token) => {
                    return (item.name).toLowerCase().includes(token) || (item.group ? item.group : '').toLowerCase().includes(token)
                });
            };
            let libOptions = []
            this.estimateClipboard.slice(1).forEach((item) => {
                if (matchLibrary(item)) {
                    libOptions.push(item);
                }
            })
            this.libraryItems = libOptions.slice(0, 50);

        },
        showPinger(item) {
            let m = this.estimate.collectedItems.items.get(Estimate.itemAsKey(item))
            return !item.bundle && (m && (m.quantity > 1))
        },
        selectExistingItem(item, close) {
            this.$emit('selected:existingItem', {item});
            this.query = item.description;
            close();
        },
        close() {
            this.$refs.dropdown.close();
        }
    },
    beforeDestroy() {
        this.$refs.dropdown.close();
    }
}
</script>
